module.exports = __webpack_public_path__ + "img/company_concept2.b15151cd.png";